<template>
  <div class="button-container">
    <ButtonPrime
      :label="testButtonLabel"
      :icon="testButtonIcon"
      :class="testButtonClass"
      :loading="isLoadingTest"
      @click="cargarMatricesTest"
      :disabled="isDisabledTest"
    />
    <ButtonPrime
      :label="practicaButtonLabel"
      :icon="practicaButtonIcon"
      :class="practicaButtonClass"
      :loading="isLoadingPractica"
      @click="cargarMatricesPractica"
      :disabled="isDisabledPractica"
    />
    <ToggleVigenciaButton
      :id-capitulo="idCapitulo"
      :usuario-id="usuarioId"
      @vigencia-toggled="onVigenciaToggled"
      @vigencia-error="onVigenciaError"
    />
  </div>
</template>

<script>
import MatrizService from '@/services/MatrizService';
import ButtonPrime from 'primevue/button';
import ToggleVigenciaButton from './ToggleVigenciaButton.vue'; // Ajusta la ruta según tu estructura

export default {
  name: 'MatrixUploader',
  components: {
    ButtonPrime,
    ToggleVigenciaButton
  },
  props: {
    idCurso: { type: Number, required: true },
    idAsignatura: { type: Number, required: true },
    idUnidad: { type: Number, default: 0 },
    idCapitulo: { type: Number, default: 0 },
    idVideo: { type: Number, default: 0 },
    usuarioId: { type: Number, required: true }
  },
  data() {
    return {
      isLoadingTest: false,
      testProcessStatus: null,
      isLoadingPractica: false,
      practicaProcessStatus: null
    };
  },
  computed: {
    testButtonLabel() {
      if (this.isLoadingTest) return 'Cargando Matrices...';
      if (this.testProcessStatus === 'success') return 'Matrices Cargadas';
      if (this.testProcessStatus === 'error') return 'Error al Cargar';
      return 'Cargar Matrices Test';
    },
    testButtonIcon() {
      if (this.isLoadingTest) return 'pi pi-spin pi-spinner';
      if (this.testProcessStatus === 'success') return 'pi pi-check';
      if (this.testProcessStatus === 'error') return 'pi pi-times';
      return 'pi pi-table';
    },
    testButtonClass() {
      if (this.isLoadingTest) return 'p-button-info';
      if (this.testProcessStatus === 'success') return 'p-button-success';
      if (this.testProcessStatus === 'error') return 'p-button-danger';
      return 'p-button-info';
    },
    isDisabledTest() {
      return this.isLoadingTest;
    },
    practicaButtonLabel() {
      if (this.isLoadingPractica) return 'Cargando Matrices...';
      if (this.practicaProcessStatus === 'success') return 'Matrices Cargadas';
      if (this.practicaProcessStatus === 'error') return 'Error al Cargar';
      return 'Cargar Matrices Práctica';
    },
    practicaButtonIcon() {
      if (this.isLoadingPractica) return 'pi pi-spin pi-spinner';
      if (this.practicaProcessStatus === 'success') return 'pi pi-check';
      if (this.practicaProcessStatus === 'error') return 'pi pi-times';
      return 'pi pi-table';
    },
    practicaButtonClass() {
      if (this.isLoadingPractica) return 'p-button-info';
      if (this.practicaProcessStatus === 'success') return 'p-button-success';
      if (this.practicaProcessStatus === 'error') return 'p-button-danger';
      return 'p-button-info';
    },
    isDisabledPractica() {
      return this.isLoadingPractica;
    }
  },
  methods: {
    async cargarMatricesTest() {
      console.log('Iniciando carga de matrices de test con parámetros:', {
        idCurso: this.idCurso,
        idAsignatura: this.idAsignatura,
        idUnidad: this.idUnidad,
        idCapitulo: this.idCapitulo,
        idVideo: this.idVideo,
        usuarioId: this.usuarioId
      });

      this.isLoadingTest = true;
      this.testProcessStatus = null;

      try {
        const payload = {
          IdCapitulo: this.idCapitulo,
          IdAsignatura: this.idAsignatura,
          IdCurso: this.idCurso,
          IdUnidad: this.idUnidad,
          UsuarioId: this.usuarioId
        };

        console.log('Enviando solicitud al endpoint /api/v2/matrices/save con payload:', payload);

        const response = await MatrizService.saveMatrices(payload);

        console.log('Respuesta del backend (test):', response);

        if (response.Message.includes("No hay suficientes preguntas")) {
          this.testProcessStatus = 'error';
          this.$emit('matrix-test-error', response.Message);
        } else if (response.Message.includes("creadas") || response.Message.includes("actualizadas")) {
          this.testProcessStatus = 'success';
          this.$emit('matrix-test-loaded', response.Message);
        } else {
          this.testProcessStatus = 'error';
          this.$emit('matrix-test-error', 'Respuesta inesperada del servidor');
        }
      } catch (error) {
        console.error('Error al cargar matrices de test:', error);
        const errorMsg = error.response?.data?.Message || error.response?.data || 'Error desconocido al cargar matrices de test';
        this.testProcessStatus = 'error';
        this.$emit('matrix-test-error', errorMsg);
      } finally {
        this.isLoadingTest = false;
        setTimeout(() => {
          this.testProcessStatus = null;
        }, 3000);
      }
    },

    async cargarMatricesPractica() {
      console.log('Iniciando carga de matrices de práctica con parámetros:', {
        idCurso: this.idCurso,
        idAsignatura: this.idAsignatura,
        idUnidad: this.idUnidad,
        idCapitulo: this.idCapitulo,
        idVideo: this.idVideo,
        usuarioId: this.usuarioId
      });

      this.isLoadingPractica = true;
      this.practicaProcessStatus = null;

      try {
        const payload = {
          IdCapitulo: this.idCapitulo,
          IdAsignatura: this.idAsignatura,
          IdCurso: this.idCurso,
          IdUnidad: this.idUnidad,
          UsuarioId: this.usuarioId
        };

        console.log('Enviando solicitud al endpoint /api/v2/matrices/practica/save con payload:', payload);

        const response = await MatrizService.saveMatricesPractica(payload);

        console.log('Respuesta del backend (práctica):', response);

        if (response.Message.includes("No hay suficientes preguntas")) {
          this.practicaProcessStatus = 'error';
          this.$emit('matrix-practica-error', response.Message);
        } else if (response.Message.includes("creadas") || response.Message.includes("actualizadas")) {
          this.practicaProcessStatus = 'success';
          this.$emit('matrix-practica-loaded', response.Message);
        } else {
          this.practicaProcessStatus = 'error';
          this.$emit('matrix-practica-error', 'Respuesta inesperada del servidor');
        }
      } catch (error) {
        console.error('Error al cargar matrices de práctica:', error);
        const errorMsg = error.response?.data?.Message || error.response?.data || 'Error desconocido al cargar matrices de práctica';
        this.practicaProcessStatus = 'error';
        this.$emit('matrix-practica-error', errorMsg);
      } finally {
        this.isLoadingPractica = false;
        setTimeout(() => {
          this.practicaProcessStatus = null;
        }, 3000);
      }
    },

    onVigenciaToggled(event) {
      console.log('Vigencia alternada:', event);
      this.$emit('chapter-vigencia-updated', event.message);
    },

    onVigenciaError(errorMsg) {
      console.error('Error en vigencia:', errorMsg);
      this.$emit('chapter-vigencia-error', errorMsg);
    }
  }
};
</script>

<style scoped>
.button-container {
  display: flex;
  flex-direction: column; /* Cambiado a columna para apilar los botones */
  gap: 10px; /* Espacio entre los botones */
}

.p-button {
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.p-button.p-button-success {
  background-color: #28a745;
  border-color: #28a745;
}

.p-button.p-button-danger {
  background-color: #dc3545;
  border-color: #dc3545;
}

.p-button.p-button-info {
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.p-button:hover {
  transform: translateY(-2px);
}
</style>